<section class="esign-key-receipt-document">
  <div class="header">
    <h1>{{ 'DOCUMENT.DOCUMENT_TYPES.LEASE_AGREEMENT.KEY_RECIEPT' | translate }}</h1>
  </div>

  <form class="esign-key-receipt-document__form astral-content-width astral-stack-l" [formGroup]="form">
    <app-information-block [text]="'ESIGNATURE.HELP_TEXT.KEY_RECEITP_DOCUMENT_SEND'"></app-information-block>

    <section class="astral-section-surface astral-stack-m">
      <h4 class="esign-key-receipt-document__section-title">{{ 'RENTALOBJECT_KEY.KEYS' | translate }}</h4>

      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
        <astral-date-picker [control]="form.controls['handOverDate']"></astral-date-picker>
      </astral-layout-group>

      @if (keys) {
        <app-esign-rental-object-keys [forms]="form.controls['keys']" [keys]="keys"></app-esign-rental-object-keys>
      }

      @if (form.controls['updateRentalObjectKeys'].value) {
        <app-information-block
          [text]="'KEYTYPE.HELP_TEXT.UPDATE_OBJECT_KEYS_YES'"
        ></app-information-block>
      }
    </section>

    <section class="astral-section-surface astral-stack-m">
      <h4 class="esign-key-receipt-document__section-title">{{ 'ESIGNATURE.ERRAND' | translate }}</h4>

      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
        <astral-toggle [control]="form.controls['informWhenSigned']" [helpText]="'ESIGNATURE.HELP_TEXT.INFORM_WHEN_SIGNED'"></astral-toggle>

        @if (form.controls['informWhenSigned'].value) {
          <astral-input
            class="astral-grid-desktop-span-2"
            [control]="form.controls['informEmailAddress']"
            [helpText]="'ESIGNATURE.HELP_TEXT.INFORM_EMAIL_ADRESSES'"
          ></astral-input>
        }
      </astral-layout-group>

      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
        <astral-input
          class="astral-grid-desktop-span-3"
          [control]="form.controls['errandDescription']"
          [helpText]="'ESIGNATURE.HELP_TEXT.DESCRIPTION'"
        ></astral-input>

        <astral-date-picker
          [control]="form.controls['expirationDate']"
          [label]="'ESIGNATURE.EXPIRATION_DATE'"
          [helpText]="'ESIGNATURE.HELP_TEXT.EXPIRATION_DATE'"
        ></astral-date-picker>
      </astral-layout-group>
    </section>

    <section class="astral-section-surface astral-stack-m">
      <h4 class="esign-key-receipt-document__section-title">{{ 'ESIGNATURE.SIGNATORIES' | translate }}</h4>

      <div class="esign-key-receipt-document__signatory-list astral-stack-m">
        @for (sform of signatoryForms; track sform; let i = $index) {
          <div
            class="esign-key-receipt-document__signatory-card astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m"
            >
            <h5 class="esign-key-receipt-document__signatory-title">
              {{ 'ESIGNATURE.SIGNATORY_X_OF_Y' | translate : { current: i + 1, total: signatoryForms.length } }}
            </h5>
            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <astral-input [control]="sform.controls['name']"></astral-input>
              <astral-select
                [control]="sform.controls['informationChannel']"
                [itemsSource]="informationChannels"
                [helpText]="'ESIGNATURE.HELP_TEXT.INFORMATION_CHANNEL'"
              ></astral-select>
              <astral-input [control]="sform.controls['email']" [type]="'email'" [inputMode]="'email'"></astral-input>
              <astral-input [control]="sform.controls['phone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
              <astral-select
                [control]="sform.controls['signingRole']"
                [itemsSource]="signingRoles"
                [helpText]="'ESIGNATURE.HELP_TEXT.SIGNING_ROLE'"
              ></astral-select>
              <astral-select [control]="sform.controls['signatureType']" [itemsSource]="signatureTypeSelection"></astral-select>
              <app-masked-text-box
                [control]="sform.controls['civicNumber']"
                [mask]="civicNumberMask"
                [helpText]="'ESIGNATURE.HELP_TEXT.CIVIC_NUMBER'"
                [maskFormat]="civicNumberMaskFormat"
              ></app-masked-text-box>
              <astral-select
                [control]="sform.controls['signatureReminderSetting']"
                [helpText]="'ESIGNATURE.HELP_TEXT.SIGNATURE_REMINDER_SETTING'"
                [itemsSource]="signatureReminderSettingSelection"
              ></astral-select>
              @if (i > 0) {
                <div class="astral-form-adjacent-action">
                  <astral-button variant="secondary" size="small" type="button" labelKey="DELETE_BTN" icon="trash" (click)="deleteSignatory(i)">
                  </astral-button>
                </div>
              }
            </astral-layout-group>
          </div>
        }
      </div>

      <div class="esign-key-receipt-document__add-signatory-action">
        <astral-button variant="primary" size="small" type="button" labelKey="ESIGNATURE.ADD_SIGNATORY" icon="plus" (click)="newSignatory()">
        </astral-button>
      </div>
    </section>

    <section class="astral-section-surface astral-stack-m">
      <app-file-upload
        [text]="'ESIGNATURE.ADD_ATTACHMENT'"
        [forms]="form.controls['attachments']"
        [allowedMimeTypes]="mimeTypes"
        icon="pdf"
        buttonVariant="primary"
      ></app-file-upload>
    </section>

    <div class="esign-key-receipt-document__actions">
      <astral-button variant="secondary" type="button" labelKey="PREVIEW_BTN" (click)="previewForm()"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      <astral-button
        variant="primary"
        type="button"
        labelKey="COMMON.SEND"
        [disabled]="form.invalid || form.disabled"
        (click)="save()"
      ></astral-button>
    </div>
  </form>
</section>
